import { render, staticRenderFns } from "./OrgTree.vue?vue&type=template&id=1bf88469&scoped=true"
import script from "./OrgTree.vue?vue&type=script&lang=js"
export * from "./OrgTree.vue?vue&type=script&lang=js"
import style0 from "./OrgTree.vue?vue&type=style&index=0&id=1bf88469&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf88469",
  null
  
)

export default component.exports